import { Injectable } from '@angular/core';
import { LoaderOverlayService } from '@epicuro-next/ataraxia/loader-overlay';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { delay, filter, switchMap, tap, withLatestFrom } from 'rxjs/operators';

import * as actions from '../actions/user-ui.actions';
import { selectOverlaysOpened } from '../selectors/user-ui.selectors';

@Injectable()
export class OverlayEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private loaderOverlayService: LoaderOverlayService,
  ) {}

  public showLoaderOverlay$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.showLoaderOverlay),
        withLatestFrom(this.store.pipe(select(selectOverlaysOpened))),
        filter(([, overlaysOpened]) => overlaysOpened === 0),
        tap(() => {
          this.loaderOverlayService.open();
        }),
      ),
    { dispatch: false },
  );

  public hideLoaderOverlay$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.hideLoaderOverlay),
        withLatestFrom(this.store.pipe(select(selectOverlaysOpened))),
        filter(([, overlaysOpened]) => overlaysOpened === 0),
        switchMap(([action]) => {
          return of(null).pipe(
            delay(action.delay ?? 0),
            tap(() => {
              this.loaderOverlayService.close();
            }),
          );
        }),
      ),
    { dispatch: false },
  );
}
